import React, {useRef, useCallback} from 'react'
import tw, { styled } from 'twin.macro'
import {Block} from 'baseui/block'
import { useAtomValue } from 'jotai'
import { path } from 'ramda'

import {Modal} from '@/components/Modal'
import Canvas from '@/components/Canvas'
import {ButtonWrapper} from '@/components/ButtonWrapper'
import { claimSpiritMachineAtom } from '@/features/spirit/atoms/claimSpiritMachineAtom'
import { currentProfileAtom } from '@/features/identity/atoms'
import { useSuccessModalVisibleAtom } from '../atoms/successModalVisibleAtom'

const ContentWrapper = styled.div`
  color: #fff;
  box-sizing: border-box;
  padding: 116px 120px 124px 120px;
  background-image: url('/static/images/userPage/modal-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom center;
  display: flex;
  gap: 160px;
  justify-content: center;
  align-items: center;

  ${tw`md:flex-col md:gap-24`}
`
// ${down('md')} {
//   flex-direction: column;
//   gap: 100px;
// }

const Title = tw.div`font-secondary font-bold text-4xl text-brand mb-5`
const Subtitle = tw.div`font-secondary font-bold text-2xl mb-12`
const Description = tw.div`font-primary font-normal text-base mb-1.5`
const Highlight = tw.span`text-brand`
// const DownloadSpirit = tw.span`font-primary font-normal text-base text-brand cursor-pointer border-b border-brand`

const CanvasBox = styled.div`
  border: 1px solid rgba(54, 250, 215, 0.3);
  filter: drop-shadow(0px 0px 60px rgba(54, 250, 215, 0.3));
`

export default function ClaimSuccessModal() {
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const [isOpen, setIsOpen] = useSuccessModalVisibleAtom()
  const profile = useAtomValue(currentProfileAtom)
  const machine = useAtomValue(claimSpiritMachineAtom)
  // const spiritNumber = machine.context.spiritCollection?[0]?.formattedNftId
  const spiritNumber = path(['context', 'spiritCollection', 0, 'formattedNftId'], machine)

  const draw = useCallback(
    (context: CanvasRenderingContext2D) => {
      if (spiritNumber && profile.displayName) {
        const img = new Image()
        img.src = '/static/images/userPage/spirit-nft.png'
        img.onload = function () {
          if (img.complete) {
            context.drawImage(img, 0, 0, 315, 560)
            context.font = '12px Orbitron,system-ui,sans-serif'
            context.fillStyle = '#ffffff'
            context.fillText(`Num. #${spiritNumber}`, 19, 443)
            context.fillText('Owned by', 19, 465)
            context.fillStyle = '#36FAD7'
            context.fillText(profile.displayName, 19, 487)
          }
        }
      }
    },
    [spiritNumber, profile]
  )

  const handleDownload = () => {
    if (canvasRef && canvasRef.current) {
      const a = document.createElement('a')
      a.href = canvasRef.current.toDataURL('image/png')
      a.download = `spirit-nft-${spiritNumber}.png`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
    setIsOpen(false)
  }

  return (
    <Modal visible={isOpen} closeable={true} onClose={() => setIsOpen(false)}>
      <ContentWrapper>
        <CanvasBox>
          <Canvas ref={canvasRef} height={560} width={315} draw={draw} />
        </CanvasBox>

        <div>
          <Title>Congratulate !</Title>
          <Subtitle>Claim Sprit successfully</Subtitle>
          <Description>
            You have successfully claimed your <Highlight>Spirit</Highlight>.
          </Description>
          <Description>
            You can now join PhalaWorld and download your{' '}
            <Highlight>Spirit NFT image</Highlight>.
          </Description>
          <Block width="236px" marginTop="48px" marginBottom="15px">
            <ButtonWrapper onClick={handleDownload}>
              DOWNLOAD YOUR SPIRIT
            </ButtonWrapper>
          </Block>
        </div>
      </ContentWrapper>
    </Modal>
  )
}
